import * as React from "react";
import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "../components/Typography";
import "./ProductValues.css";
const artImage = require("../../images/theart.jpg");
const processImage = require("../../images/theprocess.jpg");
const plantsImage = require("../../images/plants.jpg");
const storyImage = require("../../images/thinker.jpg");

const item: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  px: 5,
};

function ProductValues() {
  return (
    <Box
      component="section"
      sx={{ display: "flex", overflow: "hidden", bgcolor: "secondary.light" }}
    >
      <Container sx={{ mt: 15, mb: 30, display: "flex", position: "relative" }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={6}>
            <Box sx={item}>
              <Box
                component="img"
                src={artImage}
                alt="suitcase"
                sx={{ height: 75 }}
              />
              <Typography variant="h6" sx={{ my: 5 }}>
                The Art
              </Typography>
              <Typography variant="h5">
                Scan the World is a global project that captures cultural
                treasures through 3D scanning. These digital treasures are
                shared in the public domain, allowing people everywhere to
                explore, enjoy, and bring a little piece of history to life.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={item}>
              <Box
                component="img"
                src={processImage}
                alt="clock"
                sx={{ height: 75 }}
              />
              <Typography variant="h6" sx={{ my: 5 }}>
                The Process
              </Typography>
              <Typography variant="h5">
                We use a resin 3D printer and liquid resin to create miniature
                replicas of cultural artifacts. Each statuette is carefully
                paired with an air plant using plant-safe, waterproof
                adhesive, transforming these replicas into unique works of{" "}
                <span className="species">Living Art</span>.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={item}>
              <Box
                component="img"
                src={plantsImage}
                alt="graph"
                sx={{ height: 75 }}
              />
              <Typography variant="h6" sx={{ my: 5 }}>
                The Plants
              </Typography>
              <Typography variant="h5">
                Tillandsias, commonly known as air plants, naturally grow on
                rock faces and trees throughout Central and South America.
                Requiring no soil, these unique plants thrive with just
                light, air, and water. Our Tillandsias are sustainably
                sourced and carefully nurtured for several months in our tiny
                greenhouse before being hand-selected to adorn each
                statuette.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={item}>
              <Box
                component="img"
                src={storyImage}
                alt="thinker"
                sx={{ height: 75 }}
              />
              <Typography variant="h6" sx={{ my: 5 }}>
                The Story
              </Typography>
              <Typography variant="h5">
                This adventure began five years ago with a printing mishap: a
                Venus de Milo emerged from the printer without her head!
                Rather than let an imperfect print go to waste, I added a
                tiny Ionantha air plant where her head should have
                been&mdash;and voil&agrave;! A happy accident became the
                inspiration for our little company.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ProductValues;
